module.exports = __webpack_public_path__ + "static/img/NeoSansPro-Regular.9b83025.svg";